import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { DateFilter } from '@components';
import { addCommas, removeNonNumeric, dateConvert } from '@helper';
import { applyReasons } from '@containers/Loan/constant/loan.js';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
const LoanDetail = () => {
    const {
        LoanDetailStore: {
            lendDetails,
            updateData,
            getQryLendDetail,
            startDate,
            endDate,
            reset,
        },
    } = useStore();
    const [defaultValue, setDefaultValue] = useState('0');
    const statusBtn = {
        0: { text: '成功', color: 'btn-warning', title: '已完成撥款' },
        1: {
            text: '失敗',
            color: 'btn-danger',
            title: '',
        },
        2: {
            text: '失敗',
            color: 'btn-danger',
            title: '',
        },
        3: {
            text: '處理中',
            color: 'btn-processing',
            title: '系統檢核或撥款作業執行中',
        },
        4: {
            text: '人工撥款',
            color: 'btn-reserve',
            titel: '人工撥款',
        },
    };
    useEffect(() => {
        getQryLendDetail(defaultValue, startDate, endDate);
    }, [defaultValue, startDate, endDate]);
    useEffect(() => {
        return () => {
            reset({ startDate: '', endDate: '' });
        };
    }, []);

    return (
        <div>
            <h6 className="title fs-22 fw-bolder mb-3">借款明細</h6>

            <div className="filter-info d-sm-flex flex-nowrap justify-content-between align-items-center mb-2">
                <DateFilter
                    defaultValue={defaultValue}
                    data={lendDetails}
                    setDefaultValue={setDefaultValue}
                    updateData={updateData}
                />
            </div>

            <div className="overflow-auto fs-15 scrol_sty">
                <table
                    cellSpacing={0}
                    className="table table_sty fix-last fs-6"
                >
                    <thead>
                        <tr>
                            <th>借款申請日期</th>
                            <th>起息日期</th>
                            <th>申請書編號</th>
                            {/* <th>申請方式</th> */}
                            <th className="text-end">借款金額</th>
                            <th className="text-end">借貸手續費</th>
                            <th className="text-end">淨收付金額</th>
                            <th>借款目的</th>
                            <th className="fix">狀態</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lendDetails.map(
                            (
                                {
                                    applyDate,
                                    rateEfficientDate,
                                    applyNo,
                                    applyType,
                                    amount,
                                    fee,
                                    paymentAmount,
                                    applyReason,
                                    status,
                                    failReason,
                                },
                                index
                            ) => {
                                return (
                                    <tr key={`lendDetails ${index}`}>
                                        <th>
                                            <span className="co-name">
                                                {dateConvert(applyDate)}
                                            </span>
                                        </th>
                                        <td>
                                            {dateConvert(rateEfficientDate)}
                                        </td>
                                        <td>{applyNo}</td>
                                        {/* <td>{applyType}</td> */}
                                        <td>
                                            <div className="text-end">
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(amount)
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(fee)
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(
                                                        paymentAmount
                                                    )
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            {applyReasons
                                                .filter(
                                                    i => i.value === applyReason
                                                )
                                                .map(i => i.label)}
                                        </td>
                                        <td className="fix cur-pointer">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    failReason ? (
                                                        <Tooltip>
                                                            {failReason}
                                                        </Tooltip>
                                                    ) : (
                                                        <Tooltip>
                                                            {
                                                                statusBtn[
                                                                    status
                                                                ].title
                                                            }
                                                        </Tooltip>
                                                    )
                                                }
                                            >
                                                <span
                                                    className={`btn-state btn fs-15 text-white cur-pointer ${statusBtn[status].color}`}
                                                >
                                                    {statusBtn[status].text}
                                                </span>
                                            </OverlayTrigger>
                                        </td>
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default observer(LoanDetail);
